import { createSelector } from '@reduxjs/toolkit';

import { format } from '@hsp/utilities';

import { ApplicationState } from 'types/store';

const selectState = (state: ApplicationState) => state.dashboard;

export const selectDonorComposite = createSelector(selectState, ({ donorComposite: { data } }) => data);

export const selectDonorCompositeLoading = createSelector(selectState, ({ donorComposite: { loading } }) => loading);

export const selectDonorCompositeTotal = createSelector(selectDonorComposite, (data) => {
  return format(data.reduce((previous, current) => previous + current.value, 0));
});

export const selectTopClientMailing = createSelector(selectState, ({ topClientMailing: { data } }) => data);

export const selectTopClientMailingLoading = createSelector(
  selectState,
  ({ topClientMailing: { loading } }) => loading
);

export const selectMailByState = createSelector(selectState, ({ mailByState: { data } }) => data);

export const selectMailByStateLoading = createSelector(selectState, ({ mailByState: { loading } }) => loading);

export const selectMailInsight = createSelector(selectState, ({ mailInsights: { data } }) => data);

export const selectMailInsightLoading = createSelector(selectState, ({ mailInsights: { loading } }) => loading);

export const selectMailPerformance = createSelector(selectState, ({ mailPerformance: { data } }) => data);

export const selectMailPerformanceLoading = createSelector(selectState, ({ mailPerformance: { loading } }) => loading);

export const selectTopClientMailingTotal = createSelector(selectTopClientMailing, (data) =>
  format(
    data.reduce(
      (previous, { data: current }) => previous + current.reduce((total: number, amount: number) => total + amount, 0),
      0
    )
  )
);
